import React, { FunctionComponent } from 'react';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { DialogHeaderDiv } from './DialogHeaderDiv';
import { getHeightMegduSlov, selectTheme } from '../../utils/utils';

interface Props {
  curTheme: number;
  textColor: string;
  backgrounColor: string;
  open: boolean;
  fontSize: string;
  title: string;
  text: string;
  onClose: () => void;
}

export const DialogAnnotation: FunctionComponent<Props> = ({
  curTheme,
  textColor,
  backgrounColor,
  open,
  fontSize,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  title,
  text,
  onClose,
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <div
      style={{
        userSelect: 'none',
        WebkitUserSelect: 'none',
        WebkitTextSizeAdjust: '100%',
      }}
    >
      <Dialog
        open={open}
        fullWidth
        maxWidth="lg"
        style={{
          userSelect: 'none',
          margin: '10px',
        }}
        PaperProps={{
          sx: {
            background: selectTheme(backgrounColor, curTheme, -1),
            width: '100%',
            position: 'absolute',
            bottom: 0,
          },
        }}
      >
        <DialogTitle>
          <DialogHeaderDiv
            curTheme={curTheme}
            textColor={textColor}
            title={text}
            fontSize={fontSize}
            onClose={handleClose}
          />
        </DialogTitle>
        {false && (
          <DialogContent>
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontSize,
                textAlign: 'left',
                color: selectTheme(textColor, curTheme, -1),
                lineHeight: getHeightMegduSlov(fontSize),
              }}
            >
              {text}
            </Typography>
          </DialogContent>
        )}
      </Dialog>
    </div>
  );
};
